/**
 * Writer-facing copy for dated lines on a Note (#1315).
 */
export const DATED_NOTE_LINE_COPY = {
  region: 'Changes later in the story',
  heading: 'Changes later in the story',
  hint: "The note above is how things start. Add a change and pick the sequence (or scene) where it happens. Scenes from there on use it. Earlier scenes don't.",
  empty: 'No changes yet.',
  loading: 'Loading changes…',
  add: 'Add a change',
  textLabel: 'What changes',
  sequenceLabel: 'Starting in',
  sequencePlaceholder: 'Pick a sequence',
  save: 'Save change',
  saveChanges: 'Save change',
  cancel: 'Cancel',
  edit: 'Edit',
  remove: 'Remove change',
  unavailable: "Changes aren't available for this book yet.",
  needSequence: 'Pick a sequence.',
  needText: 'Write what changes.',
  loadError: "Couldn't load the changes.",
  saveError: "Couldn't save this change.",
  deleteError: "Couldn't remove this change.",
  noSequences: "This book doesn't have any sequences yet.",
  missingSection: 'That sequence is no longer on the outline. Pick another.',
  unnamed: 'Untitled',
};
